import { Injectable } from '@angular/core';
import { Log, LogEx, LogLevel} from '../interfaces/log.interface';
import { HttpInterceptorService } from './http-interceptor.service';
import { IspmHttpClient } from './ispm-http-client';
import { ClientLogConfig } from '../interfaces/client-log-config.interface';
import {StringUtils} from "@ispm/shared/utils/String.utils";
import { isArray } from 'lodash';

let worker: Worker = null;
let clientLogConfig: ClientLogConfig = null;

@Injectable()
export class LogService {

    private static indexedDb = null;
    private static tempLogs: LogEx[] = [];
    private static DBNAME = 'storelogs';
    private static STORENAME = 'logs';
    private static LOGS_IGNORE_LIST = ['ResizeObserver loop limit exceeded'];

    constructor(private httpsclient: HttpInterceptorService, private _ispmHttpClient: IspmHttpClient) {
        if (worker == null) {
            if (typeof (Worker) !== "undefined") {
                worker = new Worker('/workers-transpiled/processLog.js');
            } else {
                console.log('Browser does not support Web Workers..');
            }

        }

        if (clientLogConfig === null) {
            this.getClientLogConfiguration();
        }

        //TODO: Below code generating confirmation box, Handle with another approach
        // window.addEventListener('beforeunload', (e) => {
        //     this.sendAndDeleteLogs();
        //     e.preventDefault();
        //     e.returnValue = '';
        // });



        window.onerror = (errorMsg, url, lineNumber, column, errorObj) => {
            if (LogService.LOGS_IGNORE_LIST.includes(errorMsg.toString())){
                return;
            }
            console.log('Onerror called')
            console.log('Error: ' + errorMsg + ' Script: ' + url + ' Line: ' + lineNumber
                + ' Column: ' + column + ' StackTrace: ' + errorObj);


            this.error(errorMsg.toString(), 'Browser Console error')

            return false;
        }

        this.intitializeDB();

    }

    public error(mesg: string, context: string, stacktrace?: string) {
        let log: Log = {
            level: LogLevel.ERROR,
            message: mesg,
            context: context,
            stackTrace: stacktrace ? stacktrace : ''
        }

        this.log(log);
    }

    public warning(mesg: string, context: string, stacktrace?: string) {
        let log: Log = {
            level: LogLevel.WARNING,
            message: mesg,
            context: context,
            stackTrace: stacktrace ? stacktrace : ''
        }

        this.log(log);

    }
    public info(mesg: string, context: string, transactionId?: string) {

        let log: Log = {
            level: LogLevel.INFO,
            message: mesg,
            context: context,
        }

        this.log(log,transactionId);
    }
    public fatal(mesg: string, context: string, stacktrace?: string) {
        let log: Log = {
            level: LogLevel.FATAL,
            message: mesg,
            context: context,
            stackTrace: stacktrace ? stacktrace : ''
        }

        this.log(log);

    }

    public log(log: Log,transactionId?: string) {

        let userid = this.getUserId();

        const extentendLog: LogEx = {
            ...log,
            userId: userid,
            windowUrl: window.location.href,
            timestamp: new Date().toISOString(),
            transactionId: transactionId || `[${new Date().toISOString()}] - ${userid}`
        }

        if (clientLogConfig !== null) {
            this.sendToworker(extentendLog)
        } else {
            LogService.tempLogs.push(extentendLog);
        }

    }

    private getUserId() {
      let user: any = localStorage.getItem('user');
      user = JSON.parse(user);
      return user && user.id ? user.id : '';
    }

    public generateTransactionId() {
      return StringUtils.generateGuid();

    }

    public printInAutomationEnv(...args: any[]): void {
      const nonClinicalUsage = JSON.parse(sessionStorage.getItem("nonClinicalUsage"));
      if(nonClinicalUsage && nonClinicalUsage.forTestingOnly) {
        console.log(...args);
      }
    }

    private sendToworker(log: LogEx) {

        if (worker != null) {
            let data = {
                task: '',
                log: log,
                config: clientLogConfig
            }
            data = JSON.parse(JSON.stringify(data));

          worker?.postMessage(data);
        }

        worker.onmessage = (event) => {

            console.log('Recieved in the message', event.data);
            const logs = event.data.logs;
            const sendImmediately = event.data.sendImmediately;

            if (logs && isArray(logs)) {
                this.sendLogsToLoggerService(logs, sendImmediately);
            } else {
                this.sendAndDeleteLogs();
            }
        }
    }

    private getObjectStore(store_name, mode) {
        if (LogService.indexedDb === null) {
            return null;
        }
        let tx = LogService.indexedDb.transaction(store_name, mode);
        tx.onerror = (event) => {
            console.log('store logs does not exist');
        };
        return tx.objectStore(store_name);

    }


    private sendAndDeleteLogs() {

        console.log('Main Thread: send and delete logs ')

        const request = indexedDB.open(LogService.DBNAME, 1);

        if (LogService.indexedDb) {

            let store = this.getObjectStore(LogService.STORENAME, 'readonly')
            let getAllRequest = store.getAll()
            this.getLogsandDelete(getAllRequest);
            return;

        }

        request.onsuccess = () => {
            LogService.indexedDb = request.result;
            let store = this.getObjectStore(LogService.STORENAME, 'readonly')
            let getAllRequest = store.getAll()
            this.getLogsandDelete(getAllRequest);
        }

        request.onerror = () => {
            console.log('No DB found');
        }

    }

    private deletelogs() {

        let store = this.getObjectStore(LogService.STORENAME, 'readwrite')
        if (store === null) {
            console.log('DB is not intialized')
            return;
        }
        let req = store.clear()
        req.onsuccess = function () {
            console.log('successfully Cleard the IndexedDb')
        }
        req.onerror = function () {
            console.log('unable to clear IndexedDb')
        }
    }

    private getLogsandDelete(getAllRequest) {
        getAllRequest.onsuccess = () => {

            let logs = getAllRequest.result;

            if (logs.length > 0) {
                this.sendLogsToLoggerService(logs);
                console.log('sending the logs');
            } else {
                console.log('Nothing in the store to send')
            }
        }

        getAllRequest.onerror = () => {
            console.log('No store or No logs found the store')
        }
    }

    private sendLogsToLoggerService(logs, sendImmediately: boolean = false) {

        console.log('started sending  logs !!')

        this._ispmHttpClient.post('logging/log', { logs }, undefined, {}).subscribe((res) => {
            console.log('posted logs successfully response is: ', res);
            if (sendImmediately !== true) {
                this.deletelogs();
            }

        });
    }

    private intitializeDB() {
        const request = indexedDB.open(LogService.DBNAME);

        request.onsuccess = () => {
            LogService.indexedDb = request.result;
        }

        request.onerror = () => {
            console.log('No DB found');
        }
    }
    private getClientLogConfiguration() {
        this.httpsclient.get('getClientConfig').subscribe((res) => {
            clientLogConfig = res.body;

            if (LogService.tempLogs.length > 0) {
                for (let log of LogService.tempLogs) {
                    this.sendToworker(log)
                }
            }
            LogService.tempLogs = [];
        })
    }

}

